export default __webpack_public_path__ + "static/media/gs.f16e0ac4.svg";